<template>
  <el-row
    class="pageSize"
    style="margin: 0 auto; padding-top: 15px"
  >
    <el-row>
      <el-row>
        <el-col
          :span="1"
          class="el-tabs__item"
          style="height: 35px"
        >
        </el-col>
        <el-col
          :span="14"
          class="suitability_home left_text_align"
          @click.native="backHome"
          style="cursor: pointer"
        ><i class="el-icon-s-home"></i>返回主页菜单<div class="imgs_logo" /></el-col>
        <el-col
          :span="9"
          @click.native="logoutAccount"
          class="suitability_home right_text_align"
          style="cursor: pointer"
        >
          <span class="font_title_email">{{ account }}</span><span>[退出]</span>
        </el-col>
      </el-row>
    </el-row>
    <el-row
      style="width: 100%; height: 197px;">
      <el-row
        style="display:flex;width: 100%; height: 200px;align-items: flex-end;">
        <el-row class="main_bg_img" style="display:flex;width: 100%; height: 200px;"></el-row>
      </el-row>
    </el-row>

    <el-row
      style="display:flex;justify-content:center;align-items:center;width: 100%;height: auto;background-color: #FBFBFB;">
      <el-row
        style="display:flex;width: 90%; height: 100%;border: 1px solid #cccccc;box-shadow:0px 16px 21px 0px rgb(208 208 208);">
        <el-row
          style="display:flex;justify-content:center;align-items:center;width: 100%; height: 100%;background-color: #ffffff;">
          <el-row
            style="display:flex;align-items:flex-start;width: 92%;height: 100%;"
            v-loading="loading">

            <el-tabs v-model="activeName" @tab-click="handleClick" class="tabs_show_class" style="width: 100%;margin-top: 36px;">
              <el-tab-pane label="基金奖词云图" name="chart">
                
                <div style="display:flex;flex-direction: column;width: 100%;height: 815px;">
                  <div style="display: flex;width: 100%;height: 44px;justify-content: flex-end;align-items: center;">
                    <div style="display: flex;width: 184px;height: 80%;border-radius: 10px;align-items: center;justify-content: space-around;">
                    <!-- <div style="display: flex;width: 90px;height: 80%;border-radius: 10px;align-items: center;justify-content: space-around;border: 1px solid #d3d0d0;"> -->
                      <!-- <div class="switch-tag-class" :style="{'background-color': switchColor1}" @click="tagClick(1)">全部</div> -->
                      <!-- <div class="switch-tag-class" :style="{'background-color': switchColor1}" @click="tagClick(1)">获奖</div>
                      <div class="switch-tag-class" :style="{'background-color': switchColor2}" @click="tagClick(2)">提名</div> -->
                      <el-button-group>
                        <el-button :type="cssGoon1" size="medium"  round @click="tagClick(1)">获奖</el-button>
                        <el-button :type="cssGoon2" size="medium" round @click="tagClick(2)">提名</el-button>
                      </el-button-group>
                    </div>
                  </div>
                  <!-- 基金奖词云图展示 -->
                  <div id="echartsWordcloud" style="width:100%;height:600px;"></div>
                  <div style="display: flex;width: 100%;height: 40px;align-items: center;font-size: 14px;">
                    <!-- <div style="display: flex;flex: 1;justify-content: flex-start;">*获奖或提名次数越多基金字体就越大</div> -->
                    <div style="display: flex;flex: 1;justify-content: flex-start;">*截止日期: {{date}}</div>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="历年基金奖" name="award">
                <div style="display: flex;flex-direction: column;width: 100%;height: 100%;">
                  <div style="display:flex;flex-direction: column;width: 100%;height: 140px;border-bottom: 2px solid #cccccc;">
                    <div style="display:flex;width: 100%;height: 60px;">
                      <div style="display:flex;justify-content: flex-start;align-items: center;width: 250px;height: 60px;">
                        <div style="display:flex;width: 200px;height: 32px;">
                          <span style="display:flex;justify-content: flex-start;align-items: center;width: 100px;height: 100%;color: #000000;font-weight: 550;">获奖年度</span>
                          <el-select v-model="hj_value" placeholder="" size="small" @change="yearChange">
                            <el-option
                              v-for="item in yearList"
                              :key="item"
                              :label="item"
                              :value="item">
                            </el-option>
                          </el-select>
                        </div>
                      </div>
                      <div style="display:flex;justify-content: flex-start;align-items: center;width: 250px;height: 60px;">
                        <div style="display:flex;width: 200px;height: 32px;">
                          <span style="display:flex;justify-content: flex-start;align-items: center;width: 140px;height: 100%;color: #000000;font-weight: 550;">基金奖项</span>
                          <el-select v-model="jj_value" placeholder="" size="small" @change="fundAwardChange">
                            <el-option
                              v-for="item in fundAwardList"
                              :key="item"
                              :label="item"
                              :value="item">
                            </el-option>
                          </el-select>
                        </div>
                      </div>
                      <div style="display:flex;justify-content: flex-start;align-items: center;width: 250px;height: 60px;">
                        <div style="display:flex;width: 200px;height: 32px;">
                          <span style="display:flex;justify-content: flex-start;align-items: center;width: 100px;height: 100%;color: #000000;font-weight: 550;">资产类型</span>
                          <el-select v-model="zc_value" placeholder="" size="small" @change="broadCategoryChange">
                            <el-option
                              v-for="item in broadCategoryList"
                              :key="item"
                              :label="item"
                              :value="item">
                            </el-option>
                          </el-select>
                        </div>
                      </div>
                      <div style="display:flex;justify-content: flex-start;align-items: center;width: 250px;height: 60px;">
                        <div style="display:flex;width: 200px;height: 32px;">
                          <span style="display:flex;justify-content: flex-start;align-items: center;width: 100px;height: 100%;color: #000000;font-weight: 550;">基金类型</span>
                          <el-select v-model="fl_value" placeholder="" size="small" @change="fundCategoryChange">
                            <el-option
                              v-for="item in fundCategoryList"
                              :key="item"
                              :label="item"
                              :value="item">
                            </el-option>
                          </el-select>
                        </div>
                      </div>
                    </div>
                    <div style="display:flex;width: 100%;height: 60px;">
                      <div style="display:flex;justify-content: flex-start;align-items: center;width: 250px;height: 60px;">
                        <div style="display:flex;width: 200px;height: 32px;">
                          <span style="display:flex;justify-content: flex-start;align-items: center;width: 100px;height: 100%;color: #000000;font-weight: 550;">基金公司</span>
                          <el-select v-model="gs_value" clearable filterable placeholder="" size="small" @clear="clearTemp(2)" @change="fundCompanyChange">
                            <el-option
                              v-for="item in fundCompanyList"
                              :key="item"
                              :label="item"
                              :value="item">
                            </el-option>
                          </el-select>
                        </div>
                      </div>
                      <div style="display:flex;justify-content: flex-start;align-items: center;width: 250px;height: 60px;">
                        <div style="display:flex;width: 200px;height: 32px;">
                          <span style="display:flex;justify-content: flex-start;align-items: center;width: 140px;height: 100%;color: #000000;font-weight: 550;">时任基金经理</span>
                          <el-select v-model="jl_value" clearable filterable placeholder="" size="small" @clear="clearTemp(1)" @change="fundManagerChange">
                            <el-option
                              v-for="item in managerTempList"
                              :key="item"
                              :label="item"
                              :value="item">
                            </el-option>
                          </el-select>
                        </div>
                      </div>
                      <div style="display:flex;width: 250px;height: 60px;align-items: center;">
                        <div style="display:flex;width: 90px;height: 34px;">
                          <el-button type="primary" @click="searchClick()">查找</el-button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div style="display:flex;width: 100%;height: 100%;margin-top: 16px;">
                    
                    <el-table
                      :data="tableData"
                      @sort-change="sortChange"
                      :default-sort="sortTitle != 'awardYear'
                        ? { prop: sortTitle, order: 'descending' }
                        : { prop: 'awardYear', order: 'descending' }"
                      style="width: 100%;"
                      :key="Math.random()"
                    >
                      <el-table-column
                        type="index"
                        label="序号"
                        width="60"
                        :key="Math.random()"
                      ></el-table-column>
                      <el-table-column
                        sortable="custom"
                        prop="awardYear"
                        label="获奖年度"
                        width="100"
                        :key="Math.random()"
                      ></el-table-column>
                      <el-table-column
                        prop="awardType"
                        label="基金奖项"
                        width="80"
                        show-overflow-tooltip
                        :key="Math.random()"
                      >
                      </el-table-column>
                      <el-table-column
                        prop="csdcc"
                        label="基金代码"
                        width="100"
                        align="center"
                        :key="Math.random()"
                      >
                      </el-table-column>
                      <el-table-column
                        prop="fundName"
                        label="基金名称"
                        width="200"
                        :key="Math.random()"
                      >
                      </el-table-column>
                      <el-table-column
                        prop="fundCompanyShort"
                        label="基金公司"
                        width="120"
                        :key="Math.random()"
                      ></el-table-column>
                      <el-table-column
                        prop="managerName1"
                        label="时任基金经理"
                        align="center"
                        width="140"
                        :key="Math.random()"
                      >
                      <template slot-scope="scope">
                        <span v-html="mergeNameFilter(scope.row.managerName1,scope.row.managerName2,scope.row.managerName3,scope.row.managerName4)"></span> 
                      </template>
                      </el-table-column>
                      <el-table-column
                        prop="startDate1"
                        label="任职日期"
                        width="100"
                        :key="Math.random()"
                      ></el-table-column>
                      <el-table-column
                        prop="publishDate"
                        sortable="custom"
                        label="获奖日期"
                        width="100"
                        align="left"
                        :key="Math.random()"
                      ></el-table-column>
                      <el-table-column
                        prop="fundNameCurrent"
                        label="基金名称(新)"
                        width="220"
                        :key="Math.random()"
                      ></el-table-column>
                      <el-table-column
                        prop="awardsCategory"
                        label="获奖类别"
                        width="140"
                        show-overflow-tooltip
                        :key="Math.random()"
                      >
                      </el-table-column>
                      <el-table-column
                        prop="categoryName"
                        label="基金类型"
                        width="200"
                        show-overflow-tooltip
                        :key="Math.random()"
                      >
                      </el-table-column>
                    </el-table>
                  </div>
                  <div style="display:flex;width: 100%;height: 50px;margin-top: 20px;">
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page.sync="params.page"
                        :page-sizes="[10, 20, 50, 100, 200]"
                        :page-size="pagination.limit"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="(pagination && pagination.count) || 0"
                        v-if="pagination.count > 10 ? true : false"
                      >
                    </el-pagination>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="获奖公司列表" name="company">
                <div style="display: flex;flex-direction: column;width: 100%;height: 100%;">
                  <div style="display:flex;flex-direction: column;width: 100%;height: 110px;border-bottom: 2px solid #cccccc;">
                    <div style="display:flex;width: 100%;height: 60px;">
                      <div style="display:flex;justify-content: flex-start;align-items: center;width: 250px;height: 60px;">
                        <div style="display:flex;width: 200px;height: 32px;">
                          <el-autocomplete
                            class="inline-input"
                            clearable
                            v-model="companyKeyword"
                            :fetch-suggestions="querySearch"
                            placeholder="输入公司名称或首拼查找"
                            @select="handleSelect"
                            @clear="clearCompanySearch()"
                          ></el-autocomplete>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div style="display:flex;width: 100%;height: 100%;margin-top: 16px;">
                    
                    <el-table
                      :data="awardCompanyData"
                      @sort-change="sortCompanyChange"
                      :default-sort="companySortTitle != 'awardAllocCount'
                        ? { prop: companySortTitle, order: 'descending' }
                        : { prop: 'awardAllocCount', order: 'descending' }"
                      sort-orders="['descending', null]"
                      style="width: 100%;"
                      :key="Math.random()"
                    >
                      <el-table-column
                        type="index"
                        label="序号"
                        width="60"
                        :key="Math.random()"
                      ></el-table-column>
                      <el-table-column
                        prop="fundCompany"
                        label="基金公司名称"
                        width="220"
                        :key="Math.random()"
                        @click="goCompanyModule(scope.row.fundCompany)"
                      ></el-table-column>
                      <el-table-column
                        prop="inceptionDate"
                        label="成立日期"
                        width="120"
                        show-overflow-tooltip
                        :key="Math.random()"
                      >
                      </el-table-column>
                        <el-table-column
                          label=""
                          align="center"
                        >
                              <template slot="header">
                                <span>获奖次数</span>
                              </template>
                            <el-table-column
                              prop="awardAllocCount"
                              sortable="custom"
                              label="权益"
                              min-width="120"           
                              align="center"
                              style="background-color:red !important;"
                            >
                            <template slot-scope="scope">
                              <div>
                                <a href="javascript:;" style="text-decoration:none;" @click="goFundAwardPanel(1,scope.row.fundCompany)">{{scope.row.awardAllocCount}}</a>
                              </div>
                            </template>
                            </el-table-column>
                            <el-table-column
                              prop="awardFxincCount"
                              sortable="custom"
                              label="固收"
                              min-width="120"          
                              align="center"
                            >
                            <template slot-scope="scope">
                              <div>
                                <a href="javascript:;" style="text-decoration:none;" @click="goFundAwardPanel(2,scope.row.fundCompany)">{{scope.row.awardFxincCount}}</a>
                              </div>
                            </template>
                            </el-table-column>
                            <el-table-column
                              prop="awardCount"
                              sortable="custom"
                              label="合计"
                              min-width="120"           
                              align="center"
                            >
                            <template slot-scope="scope">
                              <div>
                                <a href="javascript:;" style="text-decoration:none;" @click="goFundAwardPanel(3,scope.row.fundCompany)">{{scope.row.awardCount}}</a>
                              </div>
                            </template>
                            </el-table-column>
                        </el-table-column>
                                        <el-table-column
                          label=""
                          align="center"
                        >
                              <template slot="header">
                                <span>提名次数</span>
                              </template>
                            <el-table-column
                              prop="nominateAllocCount"
                              sortable="custom"
                              label="权益"
                              min-width="120"            
                              align="center"
                              style="background-color:red !important;"
                            >
                            <template slot-scope="scope">
                              <div>
                                <a href="javascript:;" style="text-decoration:none;" @click="goFundAwardPanel(4,scope.row.fundCompany)">{{scope.row.nominateAllocCount}}</a>
                              </div>
                            </template>
                            </el-table-column>
                            <el-table-column
                              prop="nominateFxincCount"
                              sortable="custom"
                              label="固收"
                              min-width="120"           
                              align="center"
                            >
                            <template slot-scope="scope">
                              <div>
                                <a href="javascript:;" style="text-decoration:none;" @click="goFundAwardPanel(5,scope.row.fundCompany)">{{scope.row.nominateFxincCount}}</a>
                              </div>
                            </template>
                            </el-table-column>
                            <el-table-column
                              prop="nominateCount"
                              sortable="custom"
                              label="合计"
                              min-width="120"           
                              align="center"
                            >
                            <template slot-scope="scope">
                              <div>
                                <a href="javascript:;" style="text-decoration:none;" @click="goFundAwardPanel(6,scope.row.fundCompany)">{{scope.row.nominateCount}}</a>
                              </div>
                            </template>
                            </el-table-column>
                        </el-table-column>
                    </el-table>
                  </div>
                  <div style="display:flex;width: 100%;height: 50px;margin-top: 20px;">
                    <el-pagination
                        @size-change="handleSizeChange2"
                        @current-change="handleCurrentChange2"
                        :current-page.sync="awardCompanyParams.page"
                        :page-sizes="[10, 20, 50, 100, 200]"
                        :page-size="awardCompanyPagination.limit"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="(awardCompanyPagination && awardCompanyPagination.count) || 0"
                        v-if="awardCompanyPagination.count > 10 ? true : false"
                      >
                    </el-pagination>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="获奖基金经理列表" name="manager">
                <div style="display: flex;flex-direction: column;width: 100%;height: 100%;">
                  <div style="display:flex;flex-direction: column;width: 100%;height: 110px;border-bottom: 2px solid #cccccc;">
                    <div style="display:flex;width: 100%;height: 60px;">
                      <div style="display:flex;justify-content: flex-start;align-items: center;width: 250px;height: 60px;">
                        <div style="display:flex;width: 200px;height: 32px;">
                          <el-autocomplete
                            class="inline-input"
                            clearable
                            v-model="managerKeyword"
                            :fetch-suggestions="queryManagerSearch"
                            placeholder="输入基金经理名称或首拼查找"
                            @select="handleManagerSelect"
                            @clear="clearManagerSearch()"
                          ></el-autocomplete>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div style="display:flex;width: 100%;height: 100%;margin-top: 16px;">
                    
                    <el-table
                      :data="awardManagerData"
                      @sort-change="sortManagerChange"
                      :default-sort="managerSortTitle != 'awardCount'
                        ? { prop: managerSortTitle, order: 'descending' }
                        : { prop: 'awardCount', order: 'descending' }"
                      sort-orders="['descending', null]"
                      style="width: 100%;"
                      :key="Math.random()"
                    >
                      <el-table-column
                        type="index"
                        label="序号"
                        width="60"
                        :key="Math.random()"
                      ></el-table-column>
                      <el-table-column
                        prop="managerName"
                        label="基金经理名称"
                        width="120"
                        :key="Math.random()"
                      ></el-table-column>
                      <el-table-column
                        prop="awardCount"
                        sortable="custom"
                        label="获奖次数"
                        width="100"
                        show-overflow-tooltip
                        :key="Math.random()"
                      >
                      <template slot-scope="scope">
                        <div>
                          <a href="javascript:;" style="text-decoration:none;" @click="goFundAwardPanel2(1,scope.row.managerName,scope.row.broadCategoryId)">{{scope.row.awardCount}}</a>
                        </div>
                      </template>
                      </el-table-column>
                      <el-table-column
                        prop="nominateCount"
                        sortable="custom"
                        label="提名次数"
                        width="100"
                        align="center"
                        :key="Math.random()"
                      >
                      <template slot-scope="scope">
                        <div>
                          <a href="javascript:;" style="text-decoration:none;" @click="goFundAwardPanel2(2,scope.row.managerName,scope.row.broadCategoryId)">{{scope.row.nominateCount}}</a>
                        </div>
                      </template>
                      </el-table-column>
                      <el-table-column
                        prop="awardInfoList"
                        label="获奖明细"
                        width="240"
                        :key="Math.random()"
                      >
                      <template slot-scope="scope">
                        <span v-html="nullFilter(scope.row.awardInfoList)"></span> 
                      </template>
                      </el-table-column>
                      <el-table-column
                        prop="nominateInfoList"
                        label="提名明细"
                        width="240"
                        :key="Math.random()"
                      >
                      <template slot-scope="scope">
                        <span v-html="nullFilter(scope.row.nominateInfoList)"></span>
                      </template>
                      </el-table-column>
                      <!-- <el-table-column
                        prop="nowCompany"
                        label="现任基金公司(公募)"
                        align="center"
                        width="240"
                        :key="Math.random()"
                      ></el-table-column> -->
                      <el-table-column
                        prop="broadCategoryId"
                        sortable="custom"
                        label="资产类型"
                        width="100"
                        :key="Math.random()"
                      ></el-table-column>
                      <el-table-column
                        prop="fundCompanyShort"
                        label="曾任基金公司"
                        width="160"
                        align="left"
                        :key="Math.random()"
                      ></el-table-column>
                    </el-table>
                  </div>
                  <div style="display:flex;width: 100%;height: 50px;margin-top: 20px;">
                    <el-pagination
                        @size-change="handleSizeChange3"
                        @current-change="handleCurrentChange3"
                        :current-page.sync="awardManagerParams.page"
                        :page-sizes="[10, 20, 50, 100, 200]"
                        :page-size="awardManagerPagination.limit"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="(awardManagerPagination && awardManagerPagination.count) || 0"
                        v-if="awardManagerPagination.count > 10 ? true : false"
                      >
                    </el-pagination>
                  </div>
                </div>
              </el-tab-pane>
            </el-tabs>

          </el-row>
        </el-row>
      </el-row>
    </el-row>

    <br />
  </el-row>
</template>
<script>
import { Message } from "element-ui";
import {
    getAwardInfo,
    getAwardChart,
    getAwardCompany,
    getAwardManager,
    searchManager
} from "../api/award";

const componentsCommon = require("cb-components-common").default;
const checkResponseStatus = componentsCommon.common.checkResponseStatus;
const logout = componentsCommon.common.logout;
const getDisableExport = componentsCommon.common.getDisableExport;
const getRankingMemberBaseTrial = componentsCommon.common.getRankingMemberBaseTrial;
const getRankingMemberBase = componentsCommon.common.getRankingMemberBase;
const getRankingMemberSeniorTrial = componentsCommon.common.getRankingMemberSeniorTrial;
const getRankingMemberSenior = componentsCommon.common.getRankingMemberSenior;
const getNameAndValue = componentsCommon.localStorage.getNameAndValue;
const fetchFile = componentsCommon.downloadUtils.fetchFile;
const openDownloadDialog = componentsCommon.downloadUtils.openDownloadDialog;
const sheet2blob4Rank = componentsCommon.downloadUtils.sheet2blob4Rank;
const getCompanyList = componentsCommon.apiCommon.getCompanyList;
const getWorkDate = componentsCommon.apiCommon.getWorkDate;
const getFilter = componentsCommon.apiCommon.getFilter;
const searchBox = componentsCommon.mixin.searchBox.searchBox;
const exportFile = componentsCommon.mixin.exportFile.exportFile;
const componentsSuitability = require("cb-components-suitability").default;
const frequencyConfig =
    componentsSuitability.Suitability.components.LatestEvaluation.mixins[2];

export default {
    data() {
        return {
            tableData: [],
            awardCompanyData: [],
            awardManagerData: [],
            activeName: "chart",
            account: "",
            company: "",
            loading: false,
            disableExport: true,
            timeList: [],
            latestDate: "",
            pageSize: 0,
            pageSize2: 0,
            pageSize3: 0,

            hj_value: "- 全部 -",
            jj_value: "- 全部 -",
            zc_value: "- 全部 -",
            fl_value: "- 全部 -",
            gs_value: "- 全部 -",
            jl_value: "- 全部 -",

            yearList: [],
            fundAwardList: [],
            broadCategoryList: ['全部','权益','固收'],
            fundCategoryList: [],
            fundCompanyList: [],
            fundManagerAllList: [],
            fundManagerList: [],

            managerTempList: [],

            mapping: [],

            chartData: [],

            companyKeyword: '',
            companyList: [],
            managerKeyword: '',
            managerList: [],

            companyMappingList: [],

            companySortTitle: 'awardAllocCount',
            managerSortTitle: 'awardCount',
            sortTitle: 'awardYear',

            switchColor1: '#ffffff',
            switchColor2: '#e75d5d',

            cssGoon1:"goon",
            cssGoon2:"goon-focus",

            date: '',

            pagination: {
                skip: 0,
                limit: 10,
                count: 0
            },
            params: {
                awardYear: 999,
                awardType: "",
                awardsCategory: "",
                broadCategoryId: "",
                fundCompany: "",
                managerName1: "",
                sort: "awardYear",
                order: "desc",
                limit: 10,
                skip: 0
            },

            awardCompanyParams: {
                awardCompany: "",
                sort: "awardCount",
                order: "desc",
                limit: 10,
                skip: 0
            },

            awardManagerParams: {
                awardManager: "",
                sort: "awardCount",
                order: "desc",
                limit: 10,
                skip: 0
            },

            awardCompanyPagination: {
                skip: 0,
                limit: 10,
                count: 0
            },

            awardManagerPagination: {
                skip: 0,
                limit: 10,
                count: 0
            },

            // image: "data:image/png;base64,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",
            // image: "data:image/png;base64,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",

        };
    },
    mounted() {
      let self = this;
      document.documentElement.scrollTop = 0;
      self.initEcharts(2);
      let userInfo = getNameAndValue("info");
      if (userInfo != undefined && userInfo != null && userInfo != "") {
            const user = JSON.parse(userInfo);
            self.account = user.email;
      }
    },
    methods: {
      clearTemp(num) {
        let self = this;
        if (num == 1) {
          self.jl_value = "- 全部 -";
        } else if (num == 2) {
          self.gs_value = "- 全部 -";
        }
      },
      tagClick(num) {
        let self = this;
        if (num == 1) {
          // self.switchColor1 = '#e75d5d';
          // self.switchColor2 = '#ffffff';
          // self.switchColor3 = '#ffffff';
          self.cssGoon1 = 'goon-focus';
          self.cssGoon2 = 'goon';
          self.initEcharts(1);
        } else if (num == 2){
          // self.switchColor1 = '#ffffff';
          // self.switchColor2 = '#e75d5d';
          // self.switchColor3 = '#ffffff';
          self.cssGoon1 = 'goon';
          self.cssGoon2 = 'goon-focus';
          self.initEcharts(2);
        }
      },
      goFundAwardPanel(val,companyName) {
        let self = this;
        self.params.managerName1 = "";
        self.jl_value = "全部";
        if (val == 1) {
          self.activeName = "award";
          self.jj_value = self.fundAwardList[2];
          self.zc_value = self.broadCategoryList[1];
          self.gs_value = companyName;

          self.params.awardType = "获奖";
          self.params.broadCategoryId = "权益";
          self.params.fundCompany = companyName;
          self.loadingData();
        } else if (val == 2) {
          self.activeName = "award";
          self.jj_value = self.fundAwardList[2];
          self.zc_value = self.broadCategoryList[2];
          self.gs_value = companyName;

          self.params.awardType = "获奖";
          self.params.broadCategoryId = "固收";
          self.params.fundCompany = companyName;
          self.loadingData();
        } else if (val == 3) {
          self.activeName = "award";
          self.jj_value = self.fundAwardList[2];
          self.zc_value = self.broadCategoryList[0];
          self.gs_value = companyName;

          self.params.awardType = "获奖";
          self.params.broadCategoryId = "";
          self.params.fundCompany = companyName;
          self.loadingData();
        } else if (val == 4) {
          self.activeName = "award";
          self.jj_value = self.fundAwardList[0];
          self.zc_value = self.broadCategoryList[1];
          self.gs_value = companyName;

          self.params.awardType = "";
          self.params.broadCategoryId = "权益";
          self.params.fundCompany = companyName;
          self.loadingData();
        } else if (val == 5) {
          self.activeName = "award";
          self.jj_value = self.fundAwardList[0];
          self.zc_value = self.broadCategoryList[2];
          self.gs_value = companyName;

          self.params.awardType = "";
          self.params.broadCategoryId = "固收";
          self.params.fundCompany = companyName;
          self.loadingData();
        } else if (val == 6) {
          self.activeName = "award";
          self.jj_value = self.fundAwardList[0];
          self.zc_value = self.broadCategoryList[0];
          self.gs_value = companyName;

          self.params.awardType = "";
          self.params.broadCategoryId = "";
          self.params.fundCompany = companyName;
          self.loadingData();
        }
      },
      goFundAwardPanel2(val,managerName,broadCategoryId) {
          let self = this;
          self.params.fundCompany = "";
          self.gs_value = "全部";
          if (val == 1) {
            self.activeName = "award";
            self.jj_value = self.fundAwardList[2];
            self.jl_value = managerName;
            if (broadCategoryId == '权益') {
              self.zc_value = self.broadCategoryList[1];
            } else {
              self.zc_value = self.broadCategoryList[2];
            }

            self.params.awardType = "获奖";
            self.params.broadCategoryId = broadCategoryId;
            self.params.managerName1 = managerName;
            self.loadingData();
          } else if (val == 2) {
            self.activeName = "award";
            self.jj_value = self.fundAwardList[0];
            self.jl_value = managerName;
            if (broadCategoryId == '权益') {
              self.zc_value = self.broadCategoryList[1];
            } else {
              self.zc_value = self.broadCategoryList[2];
            }

            self.params.awardType = "";
            self.params.broadCategoryId = broadCategoryId;
            self.params.managerName1 = managerName;
            self.loadingData();
          }
      },
      nullFilter(params) {
        if (params == null || params == "") {
          return "--";
        } else {
          let str='';
          params.filter((item,i) => {
            str += "<span>"+item+"</span>"+"<br/>";
          });
          return str;
          // return "<span v-for='item in '"+params+"'>{{item}}</span>";
        }
      },
      mergeNameFilter(name1,name2,name3,name4) {
        let str = '';
        if (isNaN(name1)) {
          str += name1+" ";
        }
        if (isNaN(name2)) {
          str += name2+" ";
        }
        if (isNaN(name3)) {
          str += name3+" ";
        }
        if (isNaN(name4)) {
          str += name4;
        }
        return str;
      },
      querySearch(queryString, cb) {
        var companyList = this.companyList;
        var results = queryString ? companyList.filter(this.createFilter(queryString)) : companyList;
        cb(results);
      },
      queryManagerSearch(queryString, cb) {
        var managerList = this.managerList;
        var results = queryString ? managerList.filter(this.createFilter2(queryString)) : managerList;
        cb(results);
      },
      createFilter(queryString) {
        return (company) => {
          return (company.value.indexOf(queryString) === 0);
        };
      },
      createFilter2(queryString) {
        return (manager) => {
          return (manager.value.indexOf(queryString) === 0);
        };
      },
      clearCompanySearch() {
        let self = this;
        self.awardCompanyParams.awardCompany = "";
        self.getAwardCompanyData(self.awardCompanyParams);
      },
      clearManagerSearch() {
        let self = this;
        self.awardManagerParams.awardManager = "";
        self.getAwardManagerData(self.awardManagerParams);
      },
      handleSelect(item) {
        let self = this;
        self.awardCompanyParams.limit = 10;
        self.awardCompanyParams.skip = 0;
        self.awardCompanyParams.awardCompany = item.value;
        self.getAwardCompanyData(self.awardCompanyParams);
      },
      handleManagerSelect(item) {
        let self = this;
        self.awardManagerParams.limit = 10;
        self.awardManagerParams.skip = 0;
        self.awardManagerParams.awardManager = item.value;
        self.getAwardManagerData(self.awardManagerParams);
      },
      searchClick() {
          let self = this;
          self.getData(self.params);
      },
      yearChange(val) {
          let self = this;
          if (val == '全部') {
            self.params.awardYear = 999;
          } else {
            self.params.awardYear = val;
          }
      },
      fundAwardChange(val) {
          let self = this;
          self.params.awardType = val;
      },
      broadCategoryChange(val) {
          let self = this;
          self.params.broadCategoryId = val;
      },
      fundCategoryChange(val) {
          let self = this;
          self.params.awardsCategory = val;
      },
      fundCompanyChange(val) {
          let self = this;
          self.params.fundCompany = val;
          self.jl_value = '全部';
          self.params.managerName1 = '';

          for (let i = 0; i<self.mapping.length;i++) {
            if (self.mapping[i].companyName == val) {
                self.mapping[i].managerList.unshift("全部");
                self.managerTempList = self.mapping[i].managerList;
            }
          }
          // let params = {
          //   companyName: val
          // };
          // searchManager(params)
          //       .then(response => {
          //           let result = response.data;
          //           if (result == undefined) {
          //               Message({
          //                   message: "数据异常，请尝试刷新再试！",
          //                   type: "error",
          //                   duration: 2 * 1000
          //               });
          //               Message.close = function() {};
          //           } else {
          //               self.fundManagerList = result.data.selectInfo;
          //           }
          //       })
          //       .catch(err => {
          //           Message({
          //               message: "数据异常，请尝试刷新再试！",
          //               type: "error",
          //               duration: 2 * 1000
          //           });
          //           Message.close = function() {};
          //       });
      },
      fundManagerChange(val) {
          let self = this;
          self.params.managerName1 = val;
      },
      sortChange(column, prop, order) {
          let self = this;
          self.sortTitle = column.prop;
          if (column.order != undefined) {
              self.params.order = "desc";
              self.params.sort = column.prop;
              self.getData(self.params);
          }
          if (column.order == null) {
                self.params.order = "desc";
                self.params.sort = "awardYear";
                self.sortTitle = "awardYear";
                self.getData(self.params);
            }
            console.log(column + "-" + column.prop + "-" + column.order);
        },
      sortCompanyChange(column, prop, order) {
          let self = this;
          self.companySortTitle = column.prop;
            if (column.order != undefined) {
                self.awardCompanyParams.order = "desc";
                self.awardCompanyParams.sort = column.prop;
                self.getAwardCompanyData(self.awardCompanyParams);
            }
            if (column.order == null) {
                self.awardCompanyParams.order = "desc";
                self.awardCompanyParams.sort = "awardAllocCount";
                self.companySortTitle = "awardAllocCount";
                self.getAwardCompanyData(self.awardCompanyParams);
            }
            console.log(column + "-" + column.prop + "-" + column.order);
      },
      sortManagerChange(column, prop, order) {
          let self = this;
          self.managerSortTitle = column.prop;
            if (column.order != undefined) {
                self.awardManagerParams.order = "desc";
                self.awardManagerParams.sort = column.prop;
                self.getAwardManagerData(self.awardManagerParams);
            }
            if (column.order == null) {
                self.awardManagerParams.order = "desc";
                self.awardManagerParams.sort = "awardCount";
                self.managerSortTitle = "awardCount";
                self.getAwardManagerData(self.awardManagerParams);
            }
            console.log(column + "-" + column.prop + "-" + column.order);
      },
      handleSizeChange(val) {
          const self = this;
          self.params.limit = val;
          self.getData(self.params);
      },
      handleCurrentChange(val) {
          const self = this;
          self.params.page = val;
          self.params.skip = (val - 1) * self.params.limit;
          self.getData(self.params);
      },
      handleSizeChange2(val) {
          const self = this;
          self.awardCompanyParams.limit = val;
          self.getAwardCompanyData(self.awardCompanyParams);
      },
      handleCurrentChange2(val) {
          const self = this;
          self.awardCompanyParams.page = val;
          self.awardCompanyParams.skip = (val - 1) * self.awardCompanyParams.limit;
          self.getAwardCompanyData(self.awardCompanyParams);
      },
      handleSizeChange3(val) {
          const self = this;
          self.awardManagerParams.limit = val;
          self.getAwardManagerData(self.awardManagerParams);
      },
      handleCurrentChange3(val) {
          const self = this;
          self.awardManagerParams.page = val;
          self.awardManagerParams.skip = (val - 1) * self.awardManagerParams.limit;
          self.getAwardManagerData(self.awardManagerParams);
      },
      handleClick(tab, event) {
        let self = this;
        if (tab.name == 'chart') {
          self.initEcharts(2);
        } else if (tab.name == 'award') {
          self.loadingData();
        } else if (tab.name == 'company') {
          self.loadingAwardCompanyData();
        } else if (tab.name == 'manager') {
          self.loadingAwardManagerData();
        }
      },
      initEcharts(num){
        const self = this;
          let echartsWordcloud=self.$echarts.init(document.getElementById("echartsWordcloud"));

          // let mockData = [{ name: '微信', value: 3328 }, { name: '南方+', value: 1045 }, { name: '东莞时间网', value: 9999 }, { name: '东莞', value: 804 }, { name: '新浪微博', value: 532 }, { name: '今日头条', value: 493 }, { name: '腾讯新闻', value: 479 }, { name: '东莞阳光网', value: 387 }, { name: '东莞日报', value: 289 }, { name: '一点资讯', value: 287 }, { name: '东方头条网', value: 233 }, { name: '南方都市报', value: 228 }, { name: '新粤网', value: 207 }, { name: '南方plus', value: 206 }, { name: '网易新闻', value: 201 }, { name: '东方头条', value: 180 }, { name: '趣头条', value: 178 }, { name: '羊城派', value: 151 }, { name: '东莞时报', value: 143 }, { name: '莞讯网', value: 139 }, { name: '广州日报', value: 137 }, { name: '东莞阳光台', value: 132 }, { name: '搜狐新闻', value: 129 }, { name: '今日头条.APP', value: 116 }, { name: '东莞阳光平台', value: 108 }, { name: '腾讯新闻.APP', value: 107 }, { name: '南方网', value: 103 }, { name: 'UC头条', value: 98 }, { name: '凤凰新闻', value: 93 }, { name: '报告诉', value: 77 }, { name: '网易新闻.APP', value: 74 }, { name: '中国小康网', value: 64 }, { name: '东莞万江', value: 63 }, { name: '信息时报', value: 59 }, { name: '中国文明网', value: 58 }, { name: '东莞网', value: 57 }, { name: '搜狐新闻（自媒体）', value: 54 }, { name: '南方日报', value: 54 }, { name: '搜狐焦点', value: 53 }, { name: '阳光社区', value: 52 }, { name: '南方plus.APP', value: 47 }, { name: '阳光望牛墩', value: 46 }, { name: '中国报道', value: 43 }, { name: '新浪新闻', value: 43 }, { name: '房掌柜', value: 39 }, { name: '广州日报网', value: 38 }, { name: 'ZAKER', value: 38 }, { name: '一点资讯.APP', value: 35 }, { name: '聚焦东莞', value: 35 }, { name: '广州新闻网', value: 35 }, { name: '新浪', value: 31 }, { name: '东莞服务热线12345', value: 31 }, { name: '人民网', value: 29 }, { name: '阳光热线问政平台', value: 26 }, { name: '党报头条', value: 26 }, { name: '羊城晚报地方版', value: 24 }, { name: '网易房产', value: 23 }, { name: '中国网', value: 22 }, { name: '金羊网', value: 21 }, { name: '东莞长安', value: 21 }, { name: '百家号', value: 21 }, { name: '澎湃新闻', value: 20 }, { name: '读特', value: 19 }, { name: '东方头条.APP', value: 17 }, { name: '阳光石排', value: 16 }, { name: '新浪乐居', value: 16 }, { name: '微信邦', value: 16 }, { name: '搜狐新闻.APP', value: 16 }, { name: '人民日报', value: 16 }, { name: '百度新闻', value: 16 }, { name: '南方都市报.APP', value: 15 }, { name: '荔枝网', value: 15 }, { name: '华人头条', value: 15 }, { name: '广东建设报', value: 15 }, { name: '中国', value: 14 }, { name: '阳光黄江', value: 14 }, { name: '东方网', value: 14 }, { name: '网易', value: 12 }, { name: '搜狐网', value: 12 }, { name: '和讯', value: 12 }, { name: '文化莞城', value: 11 }, { name: '聊聊网', value: 11 }, { name: '58同镇', value: 11 }, { name: '凤凰网', value: 10 }, { name: '新浪网', value: 9 }, { name: '趣头条.APP', value: 9 }, { name: '凤岗网', value: 9 }, { name: '新快网_新快报', value: 8 }, { name: '上游新闻', value: 8 }, { name: '东莞市城市综合管理局', value: 8 }, { name: '大众网', value: 8 }, { name: '中国新闻网', value: 7 }, { name: '第一推', value: 7 }, { name: '大洋网', value: 7 }, { name: '新浪网', value: 6 }, { name: '新浪看点', value: 6000 }, { name: '手机和讯网', value: 6 }];
          self.loading = true;
          let params = {
            type: num
          };
          getAwardChart(params)
                .then(response => {
                    let result = response.data;
                    if (result == undefined) {
                        Message({
                            message: "数据异常，请尝试刷新再试！",
                            type: "error",
                            duration: 2 * 1000
                        });
                        Message.close = function() {};
                    } else {
                        if (checkResponseStatus(result, self)) {
                            if (
                                Number(result._meta.response_status) === 200032
                            ) {
                                Message({
                                    message:
                                        "非常抱歉，数据正在更新中，请稍后再试！",
                                    type: "warning",
                                    duration: 3 * 1000
                                });
                                Message.close = function() {};
                            } else {
                              self.chartData = result.data.selectInfo.chartInfoVoList;
                              self.companyMappingList = result.data.selectInfo.companyMappingVoList;
                              self.date = result.data.selectInfo.date;

                            // let maskImage = new Image();
                            // maskImage.src = self.image;
                            // maskImage.src = '/bsxx.png';
                            
                            // maskImage.src = "data:image/png;base64,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";
                            // maskImage.src = "data:image/png;base64,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";
                            // maskImage.src = "data:image/png;base64,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";
                            // maskImage.src = "data:image/png;base64,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";

                            // maskImage.onload = function(){
                            //     echartsWordcloud.setOption({
                            //       title: {
                            //         text: "",
                            //         x: "center"
                            //       },
                            //       series: [{
                            //         type: 'wordCloud',
                            //        gridSize: 10,
                            // //       //用来调整字的大小范围
                            //       sizeRange: [20, 50],
                            //       rotationRange: [0, 0],
                            //       // keepAspect: false,
                            //         maskImage: maskImage,
                            //         textStyle: {
                            //           normal: {
                            //             color: function() {
                            //               return 'rgb(' +
                            //                   Math.round(Math.random() * 255) +
                            //                   ', ' + Math.round(Math.random() * 255) +
                            //                   ', ' + Math.round(Math.random() * 255) + ')'
                            //             }
                            //           }
                            //         },
                            //         left: 'center',
                            //         top: 'center',
                            //         width: "300%",
                            //         height: "300%",
                            //         right: null,
                            //         bottom: null,
                            //         data: self.chartData
                            //       }]
                            //     })
                            //   }





                              let randcolor = () => {
                              let r = 100 + ~~(Math.random() * 100);
                              let g = 135 + ~~(Math.random() * 100);
                              let b = 100 + ~~(Math.random() * 100);
                                return `rgb(${r}, ${g}, ${b})`
                            }
                            let option = {
                              title: {
                                text: "",
                                x: "center"
                              },
                              series: [
                                {
                                  type: "wordCloud",
                                  //用来调整词之间的距离
                                  gridSize: 10,
                                  //用来调整字的大小范围
                                  sizeRange: [12, 60],
                                  rotationRange: [0, 0],
                                  // rotationStep: 20,
                                  // maskImage: maskImage,
                                  shape: 'star',
                                  width: '60%',
                                  height: '60%',
                                  //随机生成字体颜色
                                  textStyle: {
                                    // color: params => {
                                    //   return randcolor()
                                    // },
                                        color: function() {
                                            var colors = [
                                                "#FC6436",
                                                "#B20C24",
                                                "#D6A98C",
                                                "#C2B6AF",
                                                "#D2AA92",
                                                "#B2151A",
                                            ];
                                            return colors[parseInt(Math.random() * 6)];
                                        },
                                    emphasis: {
                                      shadowBlur: 10,
                                      shadowColor: '#333'
                                    }
                                  },
                                  //位置相关设置
                                  left: "center",
                                  top: "center",
                                  right: "center",
                                  bottom: "center",
                                  width: "300%",
                                  height: "350%",
                                  //数据
                                  data: self.chartData
                                }
                              ]
                            };
                            echartsWordcloud.setOption(option);
                            // maskImage.onload = function(){echartsWordcloud.setOption(option)};


                            let userInfo = getNameAndValue("info");
                            //点击事件
                              echartsWordcloud.on("click",function(e){
                                  if (userInfo.fundSelection != 0 || userInfo.fundSelectionMemberBase) {
                                    let companyId;
                                    for (let i = 0; i<self.companyMappingList.length;i++) {
                                      if (self.companyMappingList[i].companyName.includes(e.name)) {
                                          companyId = self.companyMappingList[i].companyId;
                                      } else {
                                        let name = e.name;
                                        const startIndex = name.indexOf("（");
                                        const endIndex = name.indexOf(")", startIndex);
                                        const result = name.substring(startIndex, endIndex);
                                        const result2 = name.substring(startIndex+1);
                                        if (self.companyMappingList[i].companyName.includes(result) && self.companyMappingList[i].companyName.includes(result2)) {
                                            companyId = self.companyMappingList[i].companyId;
                                        }
                                      }
                                    }
                                    self.$router.push({
                                      name: 'CompanyReport',
                                      params : { companyId: companyId }
                                    });
                                  } else {
                                    self.handleMessage();
                                  }
                              });

                            }
                        }
                    }
                })
                .catch(err => {
                    Message({
                        message: "数据异常，请尝试刷新再试！",
                        type: "error",
                        duration: 2 * 1000
                    });
                    Message.close = function() {};
                })
                .finally(r => {
                    self.loading = false;
                });
      },
      loadingData() {
        this.getData(this.params);
      },
      loadingAwardCompanyData() {
        this.getAwardCompanyData(this.awardCompanyParams);
      },
      loadingAwardManagerData() {
        this.getAwardManagerData(this.awardManagerParams);
      },
      getData(params) {
            const self = this;
            self.loading = true;
            getAwardInfo(params)
                .then(response => {
                    let result = response.data;
                    if (result == undefined) {
                        Message({
                            message: "数据异常，请尝试刷新再试！",
                            type: "error",
                            duration: 2 * 1000
                        });
                        Message.close = function() {};
                    } else {
                        if (checkResponseStatus(result, self)) {
                            if (
                                Number(result._meta.response_status) === 200032
                            ) {
                                Message({
                                    message:
                                        "非常抱歉，数据正在更新中，请稍后再试！",
                                    type: "warning",
                                    duration: 3 * 1000
                                });
                                Message.close = function() {};
                            } else {
                                self.pagination = result.pagination;
                                self.pageSize = result.pagination.count;
                                self.tableData = result.data.selectInfo.awardInfoVoList;
                                self.yearList = result.data.selectInfo.yearList;
                                self.fundAwardList = result.data.selectInfo.fundAwardList;
                                self.fundCategoryList = result.data.selectInfo.fundCategoryList;
                                self.fundCompanyList = result.data.selectInfo.fundCompanyList;
                                self.fundManagerAllList = result.data.selectInfo.fundManagerList;
                                self.mapping = result.data.selectInfo.mappingVoList;

                                if (self.gs_value == '全部' || self.gs_value == '- 全部 -') {
                                  self.managerTempList = self.fundManagerAllList;
                                }

                                self.yearList.unshift('全部');
                                self.fundAwardList.unshift('全部');
                                self.fundCategoryList.unshift('全部');
                                self.fundCompanyList.unshift('全部');
                                self.fundManagerList.unshift('全部');
                            }
                        }
                    }
                })
                .catch(err => {
                    Message({
                        message: "数据异常，请尝试刷新再试！",
                        type: "error",
                        duration: 2 * 1000
                    });
                    Message.close = function() {};
                })
                .finally(r => {
                    self.loading = false;
                });
        },
        getAwardCompanyData(params) {
            const self = this;
            self.loading = true;
            getAwardCompany(params)
                .then(response => {
                    let result = response.data;
                    if (result == undefined) {
                        Message({
                            message: "数据异常，请尝试刷新再试！",
                            type: "error",
                            duration: 2 * 1000
                        });
                        Message.close = function() {};
                    } else {
                        if (checkResponseStatus(result, self)) {
                            if (
                                Number(result._meta.response_status) === 200032
                            ) {
                                Message({
                                    message:
                                        "非常抱歉，数据正在更新中，请稍后再试！",
                                    type: "warning",
                                    duration: 3 * 1000
                                });
                                Message.close = function() {};
                            } else {
                                self.awardCompanyPagination = result.pagination;
                                self.pageSize2 = result.pagination.count;
                                self.awardCompanyData = result.data.selectInfo.companyInfoVoList;

                                self.companyList = result.data.selectInfo.companyList;
                            }
                        }
                    }
                })
                .catch(err => {
                    Message({
                        message: "数据异常，请尝试刷新再试！",
                        type: "error",
                        duration: 2 * 1000
                    });
                    Message.close = function() {};
                })
                .finally(r => {
                    self.loading = false;
                });
        },
        getAwardManagerData(params) {
            const self = this;
            self.loading = true;
            getAwardManager(params)
                .then(response => {
                    let result = response.data;
                    if (result == undefined) {
                        Message({
                            message: "数据异常，请尝试刷新再试！",
                            type: "error",
                            duration: 2 * 1000
                        });
                        Message.close = function() {};
                    } else {
                        if (checkResponseStatus(result, self)) {
                            if (
                                Number(result._meta.response_status) === 200032
                            ) {
                                Message({
                                    message:
                                        "非常抱歉，数据正在更新中，请稍后再试！",
                                    type: "warning",
                                    duration: 3 * 1000
                                });
                                Message.close = function() {};
                            } else {
                                self.awardManagerPagination = result.pagination;
                                self.pageSize3 = result.pagination.count;
                                self.awardManagerData = result.data.selectInfo.awardManagerInfoVoList;

                                self.managerList = result.data.selectInfo.managerInfoVoList;
                            }
                        }
                    }
                })
                .catch(err => {
                    Message({
                        message: "数据异常，请尝试刷新再试！",
                        type: "error",
                        duration: 2 * 1000
                    });
                    Message.close = function() {};
                })
                .finally(r => {
                    self.loading = false;
                });
        },
      logoutAccount() {
            let self = this;
            logout(self);
        },
      backHome() {
            let self = this;
            /*
            self.$router.push({
                path: "/home"
            });
            */
            self.$router.go(-1);
        },
    }
}
</script>
<style lang="scss">

.red span {
    border: 1px solid red;
    border-radius: 50%;
}

#elselectFundOrCompany.el-input__inner {
    width: 100px !important;
    margin-right: -10px !important;
    border-top-right-radius: 0px !important;
    border-bottom-right-radius: 0px !important;
}

#elselectCompany.el-input__inner,
#elselectFund.el-input__inner {
    border-top-left-radius: 0px !important;
    border-bottom-left-radius: 0px !important;
}

.main_bg_img {
  display: flex;
  background: url("../../../src/public/images/award.png") center no-repeat; 
  background-size:100% 100%;
}

</style>

<style scoped>
.tabs_show_class >>> .el-tabs__item.is-top {
  font-size: 17px !important;
  font-weight: 545 !important;
}

.tabs_show_class >>> .el-tabs__active-bar.is-top {
  background-color: red !important;
  height: 5px !important;
}

.el-table /deep/ .sort-caret.ascending {
  display: none;
}

.el-table /deep/ .sort-caret.descending {
  bottom: 10px;
}

.switch-tag-class {
  display: flex;
  font-size: 15px;
  width: 40px;
  height: 90%;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 10px;
}

.el-button--goon-focus, .el-button--goon:hover {
  color: #FF0000 !important;
}
</style>